/**
 * Auth
 */
export const TUTOR_SIGN_UP                     = 'TUTOR_SIGN_UP';
export const TUTOR_SIGN_UP_SUCCESS             = 'TUTOR_SIGN_UP_SUCCESS';
export const TUTOR_SIGN_UP_FAIL                = 'TUTOR_SIGN_UP_FAIL';

export const TUTOR_PROFILE_UPDATE              = 'TUTOR_PROFILE_UPDATE';
export const TUTOR_PROFILE_UPDATE_SUCCESS      = 'TUTOR_PROFILE_UPDATE_SUCCESS';
export const TUTOR_PROFILE_UPDATE_FAIL         = 'TUTOR_PROFILE_UPDATE_FAIL';

/**
 * School
 */
export const GET_SCHOOLS                     = 'GET_SCHOOLS';
export const GET_SCHOOLS_SUCCESS             = 'GET_SCHOOLS_SUCCESS';
export const GET_SCHOOLS_FAIL                = 'GET_SCHOOLS_FAIL';

/**
 * City
 */
export const GET_CITIES                     = 'GET_CITIES';
export const GET_CITIES_SUCCESS             = 'GET_CITIES_SUCCESS';
export const GET_CITIES_FAIL                = 'GET_CITIES_FAIL';

/**
 * Level
 */
export const GET_LEVELS                     = 'GET_LEVELS';
export const GET_LEVELS_SUCCESS             = 'GET_LEVELS_SUCCESS';
export const GET_LEVELS_FAIL                = 'GET_LEVELS_FAIL';

/**
 * Subject
 */
export const GET_SUBJECTS                   = 'GET_SUBJECTS';
export const GET_SUBJECTS_SUCCESS           = 'GET_SUBJECTS_SUCCESS';
export const GET_SUBJECTS_FAIL              = 'GET_SUBJECTS_FAIL';
